<template>
  <v-card class="mb-3">
    <v-list-item>
      <v-list-item-content>
        {{$t('recriptTypenoe_title1')}}
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <div v-show="is_vending_machine">
          <div class="mb-n3">
            <p>確認付款完成後，CheerLife 會再寄送電子發票至訂購人 Email。</p>
          </div>
        </div>
        <div>
          <div class="mb-n3">
            <p>{{$t('recriptTypenoe_text1')}}</p>
          </div>
        </div>
        <div v-show="!is_vending_machine">
          <div class="mb-n3">
            <v-radio-group v-model="ReceiptradioGroup">
              <v-radio
                :label="$t('recriptTypenoe_button1')"
                value="2"
              ></v-radio>
            </v-radio-group>
            <!-- <p>{{ this.order_name }}<p/>
            <p>{{ this.order_address }}</p> -->
          </div>
          <v-divider></v-divider>
          <div>
            <v-checkbox
              v-model="ReimbursecheckboxGroup"
              :label="$t('recriptTypenoe_button2')"
              @change="onReimburseChange($event)"
            ></v-checkbox>
          </div>
          <div v-if="ReimbursecheckboxGroup">
            <v-text-field
              :label="reimbursecheckbox[0].name"
              v-model.lazy="$store.state.userinfo.userinfoData[0].receipt_company_id"
              single-line
              outlined
            ></v-text-field>
            <v-text-field
              :label="reimbursecheckbox[1].name"
              v-model.lazy="$store.state.userinfo.userinfoData[0].receipt_company_name"
              single-line
              outlined
            ></v-text-field>
          </div>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'recriptTypenoe',
  props: ['getreceiptinfodata', 'getisvendingmachine'],

  data: function () {
    return {
      access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
      user_uuid: '',
      group_uuid: '',
      // 訂購人地址
      // order_name: '',
      // order_address: '',
      // 智販機
      is_vending_machine: this.getisvendingmachine,
      // 發票
      ReceiptradioGroup: '2',
      // 報帳
      ReimbursecheckboxGroup: false,
      reimbursecheckbox: [
        {
          'name': this.$t('recriptTypenoe_input1'),
          // 'reimburse_info': this.getreceiptinfodata[0].receipt_company_id,
          'reimburse_info': '',
        },
        {
          'name': this.$t('recriptTypenoe_input2'),
          // 'reimburse_info': this.getreceiptinfodata[0].receipt_company_name,
          'reimburse_info': '',
        }
      ],
    }
  },
  computed: {
  },
  methods: {
    onReimburseChange(event) {
      if (event === false) {
        this.reimbursecheckbox[0].reimburse_info = '';
        this.reimbursecheckbox[1].reimburse_info = '';
        this.$store.state.userinfo.userinfoData[0].receipt_company_id = '';
        this.$store.state.userinfo.userinfoData[0].receipt_company_name = '';
      }
    },
    // setOrderinfo() {
    //   this.order_name = this.$store.state.orderinfo.orderinfoData[0].order_name;
    //   this.order_address = this.$store.state.orderinfo.orderinfoData[0].order_address;
    // },
  },
  mounted() {
    // this.setOrderinfo();
  },
  watch: {
  },
};
</script>
